<div class="modal-body relative">
  <header class="header modal-header flex flex-col gap-2 place-content-between">
    <div class="flex justify-between">
      <h2 class="modal-headline" i18n>Export Downloads</h2>
      <button mat-icon-button mat-dialog-close class="button-close">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        <span class="sr-only" i18n>Close</span>
      </button>
    </div>
  </header>
  <div class="flex-col gap-3 bg-white h-full">
    <div class="modal-main flex justify-between w-full !min-h-[300px]">
      <div class="flex flex-col mx-4 w-full max-h-[450px] overflow-scroll">
        <span>{{ assetName }}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer flex flex-col !justify-between w-full gap-2 !items-end">
    <mat-hint class="mat-mdc-form-field-error" *ngIf="(assetDownloadHistoryCount$ | async) === 0" i18n>No download data for selected assets available.</mat-hint>
    <button (click)="exportDownloads()" class="button-primary ml-auto" mat-flat-button [disabled]="(assetDownloadHistoryCount$ | async) === 0">
      <ng-container i18n>Export Excel</ng-container>
      <mat-icon class="material-icons-outlined ml-2">upload_file</mat-icon>
    </button>
  </div>
</div>
